export const googlePayScriptSrc = 'https://pay.google.com/gp/p/js/pay.js';
export default googlePayScriptSrc;
